<template>
    <v-layout row wrap>
        <v-flex xs12>
            <correos></correos>
        </v-flex>
        <v-flex xs12>
            <Documentos></Documentos>
        </v-flex>
        <v-flex xs12>
            <Llamadas></Llamadas>
        </v-flex>
        <v-flex xs12>
            <Videos></Videos>
        </v-flex>
    </v-layout>
</template>
<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import correos from '@/components/pages/Archivos/Correos.vue';
import Documentos from '@/components/pages/Archivos/Documentos.vue';
import Llamadas from '@/components/pages/Archivos/Llamadas.vue';
import Videos from '@/components/pages/Archivos/VideosReporte.vue';

    export default {
        title() {
            return this.$route.meta.title
        },
    components: {
        correos,
        Documentos,
        Llamadas,
        Videos
    },
    data: function () {
        return {
            vicorreo: false,
            villamada: false,
            vidocumento: false,
        }
    },
    computed: {
        ...mapState([
            "domain",
            "informationPage",
            "paginacion",
            "permission",
            "user"
        ])
    },
    mounted() {
        this.changeReporteMenuOption('NoView');
        this.$root.$on('inicio');
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
    }
}
</script>